import { useState } from 'react';

type ModalState = {
  isOpen: boolean;
  close(): void;
  open(): void;
};

export const useModalState = ({
  initialState = false,
  onClose,
  onOpen,
}: {
  initialState?: boolean;
  onClose?: () => void;
  onOpen?: () => void;
}): ModalState => {
  const [isOpen, setIsOpen] = useState(initialState);
  const open = () => {
    onOpen?.();
    setIsOpen(true);
  };

  const close = () => {
    onClose?.();
    setIsOpen(false);
  };

  return {
    isOpen,
    close,
    open,
  };
};
